import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationType, getNotificationPanelClass } from './notification.constants';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showNotification(type: NotificationType, message: string, action?: string) {
    const panelClass = getNotificationPanelClass(type);

    this.snackBar.open(message, action, {
      panelClass: [panelClass],
      duration: 5000,
    });
  }
}
